"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _data = require("emoji-mart/dist/utils/data");

var _utils = require("emoji-mart/dist/utils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var skinTones = ['', '🏻', '🏼', '🏽', '🏾', '🏿'];

var getEmojiDataFromNative = function getEmojiDataFromNative(data, set) {
  return function (nativeString) {
    if (data.compressed) {
      (0, _data.uncompress)(data);
    }

    var skin;
    var baseNativeString = nativeString;
    skinTones.forEach(function (skinTone) {
      baseNativeString = baseNativeString.replace(skinTone, '');

      if (nativeString.indexOf(skinTone) > 0) {
        skin = skinTones.indexOf(skinTone) + 1;
      }
    }); // $FlowFixMe

    var emojiData = Object.values(data.emojis).find( // $FlowFixMe
    function (emoji) {
      return (0, _utils.unifiedToNative)(emoji.unified) === baseNativeString;
    });

    if (!emojiData) {
      return null;
    }

    var _emojiData$short_name = _slicedToArray(emojiData.short_names, 1),
        id = _emojiData$short_name[0];

    emojiData.id = id;
    return (0, _utils.getSanitizedData)(emojiData, skin, set, data);
  };
};

var _default = getEmojiDataFromNative;
exports.default = _default;